import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import {connect} from 'react-redux';
import {UserStyles} from './UserStyles';
import UserModal from './UserModal';
import moment from 'moment';
import { isEmpty } from 'lodash';


const useStyles = makeStyles({
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
});


function ViewUser(props) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  return (
    <>
    <Paper style={UserStyles.padding}>
      <h3 style={UserStyles.headingColor}>User Details</h3>
      { open && <UserModal open = {open}/>}
      
    
        <Typography variant="h6" component="h2" style={UserStyles.headingColor} >
        First Name
        </Typography>
        <Typography className={classes.pos} color="textSecondary">
          {props.selectedUser.first_name}
        </Typography>
        <Typography variant="h6" component="h2" style={UserStyles.headingColor} >
        Last Name
        </Typography>
        <Typography className={classes.pos} color="textSecondary">
          {props.selectedUser.last_name}
        </Typography>
        <Typography variant="h6" component="h2" style={UserStyles.headingColor}>
        Email Address
        </Typography>
        <Typography className={classes.pos} color="textSecondary">
        {props.selectedUser.email}
        </Typography>
        <Typography variant="h6" component="h2" style={UserStyles.headingColor}>
         Phone Number
        </Typography>
        <Typography className={classes.pos} color="textSecondary">
        {props.selectedUser.phone}
        </Typography>
        <Typography variant="h6" component="h2" style={UserStyles.headingColor}>
        City
        </Typography>
        <Typography className={classes.pos} color="textSecondary">
          {props.selectedUser.city}
        </Typography>
        <Typography variant="h6" component="h2" style={UserStyles.headingColor}>
        Joining Date
        </Typography>
        <Typography className={classes.pos} color="textSecondary">
        {
        moment(props.selectedUser.date_created).format('MM-DD-YYYY')
}
        </Typography>
        <Typography variant="h6" component="h2" style={UserStyles.headingColor}>
        Pakage Name
        </Typography>
        <Typography className={classes.pos} color="textSecondary">
          {props.selectedUser.package_name}
        </Typography>
        <Typography variant="h6" component="h2" style={UserStyles.headingColor}>
        Last Login
        </Typography>
        <Typography className={classes.pos} color="textSecondary">
          {
            !isEmpty(props.selectedUser.last_login) ? moment(props.selectedUser.last_login).format('MM-DD-YYYY') : "Never Login"
          }
        </Typography>
        
        </Paper>
    </>
  )
}
const mapStateToProps =(state, ownProps, number)  =>({
  user : state.dashboardReducer.selectedViewData,
  selectedUser: state.usersReducer.selectedUser,
})

export default connect(mapStateToProps,null)(ViewUser);
